import { ToolboxItem } from '../../canvas/tooling/ToolboxItem';
import { textTool } from './TextTool';
import { TextWidget } from './TextWidget';

export const textToolboxItem = ToolboxItem({
    id: 'textTool',
    label: 'Text',
    ui: TextWidget,
    weight: 3020,
    tools: [textTool]
});
